interface ToastMessageProps {
  message: string | null
  type?: 'success' | 'error' | 'info'
}

export const ToastMessage = ({ message, type = 'info' }: ToastMessageProps) => {
  if (!message) return null

  const bgColor = {
    success: 'bg-green-100 text-green-800',
    error: 'bg-red-100 text-red-800',
    info: 'bg-blue-100 text-blue-800',
  }[type]

  return (
    <div
      className={`mb-4 px-4 py-2 rounded font-medium transition-opacity duration-500 ${bgColor}`}
    >
      {message}
    </div>
  )
}
